export default __webpack_public_path__ + "static/media/monkey10.59652982.jpeg";